import { render, staticRenderFns } from "./PPCHeader.vue?vue&type=template&id=0b642f1d&"
import script from "./PPCHeader.vue?vue&type=script&lang=js&"
export * from "./PPCHeader.vue?vue&type=script&lang=js&"
import style0 from "./PPCHeader.vue?vue&type=style&index=0&id=0b642f1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default,UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default})
